import { VStack, HStack, Text, Icon, useColorModeValue } from '@ecoinvent/ui';
import { BiGlobe } from 'react-icons/bi';
import { FiLayers } from 'react-icons/fi';

import { formatNumericalValue } from 'utilities/numbers';

type SummaryCardProps = {
  totalAmount: number;
  commonUnit: string;
  geographyCount: number;
  sourceCount: number;
};

export const SummaryCard = ({ totalAmount, commonUnit, geographyCount, sourceCount }: SummaryCardProps) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const textColor = useColorModeValue('gray.800', 'gray.100');
  const labelColor = useColorModeValue('gray.600', 'gray.400');
  const metaTextColor = useColorModeValue('gray.500', 'rgba(255, 255, 255, 0.92)');

  return (
    <VStack
      align="start"
      spacing={1}
      fontSize="sm"
      backgroundColor={cardBg}
      px={4}
      py={3}
      borderRadius="md"
      border="1px solid"
      borderColor={borderColor}
      shadow="sm"
      pointerEvents="none"
    >
      <Text color={labelColor} fontSize="xs">
        All suppliers
      </Text>
      <Text fontSize="2xl" fontWeight="bold" color={textColor}>
        {formatNumericalValue(totalAmount)} {commonUnit}
      </Text>
      <HStack spacing={3} fontSize="xs" color={metaTextColor}>
        <HStack spacing={1}>
          <Icon as={BiGlobe} w={3} h={3} />
          <Text>{geographyCount} geographies</Text>
        </HStack>
        <HStack spacing={1}>
          <Icon as={FiLayers} w={3} h={3} />
          <Text>{sourceCount} sources</Text>
        </HStack>
      </HStack>
    </VStack>
  );
};
